export default __webpack_public_path__ + "static/media/home_icon.d1e51cc1.svg";